import React from 'react';
import Button from 'components/v2/buttons/Button';
import { useErrorBoundary } from 'react-error-boundary';
import CollapsibleItem from 'components/v2/list/CollapsibleItem';
import Card from 'components/v2/panels/Card';
import CircleButton from 'components/v2/buttons/CircleButton';
import { ClipboardIcon } from '@heroicons/react/20/solid';
import CopyToClipboard from 'react-copy-to-clipboard';
import { showToast } from 'stores/ToastStore';
import SessionStore from 'stores/SessionStore';
export default function ErrorPage({ error }) {
    const { resetBoundary } = useErrorBoundary();
    function handleReset() {
        resetBoundary();
    }
    function handleCopy() {
        showToast('Copied Error Message', null, 'info');
    }
    function renderTitle() {
        return (React.createElement("div", { className: "flex items-center" },
            React.createElement("span", null, error.message)));
    }
    return (React.createElement("main", { className: "grid sm:place-items-center px-6 py-24 sm:py-32 lg:px-8 min-h-screen" },
        React.createElement(Card, { className: "" },
            React.createElement("p", { className: "text-base font-semibold text-green-600" }, "500"),
            React.createElement("h3", { className: "my-4" }, "Oops, we ran into a problem!"),
            SessionStore.isAdmin() && (React.createElement(CollapsibleItem, { renderTitle: renderTitle, defaultOpen: true },
                React.createElement("pre", { className: "mt-2" }, error.stack),
                React.createElement("div", { className: "flex justify-end mt-2" },
                    React.createElement(CopyToClipboard, { text: error.stack, onCopy: handleCopy },
                        React.createElement(Button, { color: "gray", className: "inline-flex space-x-1 items-center text-sm button" },
                            React.createElement(ClipboardIcon, { className: "w-5 h-5 mr-1" }),
                            React.createElement("span", null, "Copy")))))),
            React.createElement("div", { className: "mt-10 flex items-center justify-end sm:gap-x-6 flex-wrap" },
                React.createElement("a", { href: "mailto:internalsupport@cargomatic.com", className: "button button-green mt-4 sm:mt-0" },
                    "Contact support ",
                    React.createElement("span", { "aria-hidden": "true" }, "\u2192")),
                React.createElement(Button, { onClick: handleReset }, "Close")))));
}
